<template>
    <div class="container-fluid">
        <div class="container-fluid">
            <div class="row my-3">
                <div class="col-12">
                    <a v-if="return_route" :href="return_route" class="mr-auto ml-0">
                        <button type="button" class="btn btn-default ">
                            {{ $lang('Wróć') }}
                        </button>
                    </a>
                    <button type="button" class="btn btn-primary ml-auto mr-0 pull-right"
                            data-toggle="modal" data-target="#new_person_modal">{{ $lang('Dodaj osobę') }}
                    </button>
                </div>
            </div>

            <div v-if="search_form===true" @keyup.enter="onEnterSearch">
                <div class="row col-12 mx-0 px-0">
                    <div class="col-12 col-xl-4 px-0 pr-xl-2  pl-xl-0 form-group">
                        <strong><label for="name">{{ $lang('Imię ') }}</label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                            </div>
                            <input type="text" class="form-control" name="name" id="name" v-model="searchParams.name"
                                   :placeholder="$lang('Imię')">
                        </div>
                    </div>

                    <div class="col-12 col-xl-4 px-0  pl-xl-2 pr-xl-0 form-group">
                        <strong><label for="surname">{{ $lang('Nazwisko ') }}</label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                            </div>
                            <input type="text" class="form-control" name="surname" id="surname"
                                   v-model="searchParams.surname"
                                   :placeholder="$lang('Nazwisko')">
                        </div>
                    </div>
                    <div class="col-12 col-xl-4 px-0  pl-xl-2 pr-xl-0 form-group">
                        <strong><label for="email">{{ $lang('Adres e-mail ') }} </label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-envelope-o" aria-hidden="true"></i></div>
                            </div>
                            <input type="text" class="form-control" name="email" id="email"
                                   v-model="searchParams.email"
                                   :placeholder="$lang('Email')">
                        </div>
                    </div>
                </div>

                <div class="row col-12 mx-0 px-0">
                    <div class="col-12 col-xl-8 px-0 px-0 pr-xl-2 pl-xl-0 form-group">
                        <strong><label for="library">{{ $lang('Biblioteka') }} </label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-university" aria-hidden="true"></i></div>
                            </div>
                            <select id="library" name="library" class="form-control" v-model="searchParams.library">
                                <option value="">{{ $lang('Wszystkie') }}</option>
                                <option v-for="library in libraries" :value="library.id">{{ library.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-xl-4 px-0  pl-xl-2 pr-xl-0 form-group">
                        <strong><label for="worker_type">{{ $lang('Typ pracownika') }}</label></strong>
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="bg-icon"><i class="fa fa-users" aria-hidden="true"></i></div>
                            </div>
                            <select v-model="searchParams.worker_type" id="worker_type" name="worker_type"
                                    class="form-control">
                                <option value='all'>{{ $lang('Wszyscy') }}</option>
                                <option value='sbs'>{{ $lang('Pracownik SBS') }}</option>
                                <option value='other'>{{ $lang('Inny pracownik') }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row form-group" id="checkboxes" v-if="searchParams.worker_type==='sbs'">
                    <div class="col-auto">
                        <input type="checkbox" id="consultant" name="consultant" v-model="searchParams.consultant"/>
                        <label for="consultant">{{ $lang('Konsultant') }}</label>
                    </div>

                    <div class="col-auto">
                        <input type="checkbox" id="programmer" name="programmer" v-model="searchParams.programmer"/>
                        <label for="programmer">{{ $lang('Programista') }}</label>
                    </div>

                    <div class="col-auto">
                        <input type="checkbox" id="installation" name="installation"
                               v-model="searchParams.installation"/>
                        <label for="installation">{{ $lang('Instalator') }}</label>
                    </div>
                </div>

                <div class="row form-group" id="checkboxes-role" v-if="searchParams.worker_type==='other'">
                    <div class="col-auto" v-for="searchRole in searchParams.roles" v-if="searchRole.name !==  sbs_role_name">
                        <input type="checkbox" :id="searchRole.name" :name="searchRole.name"
                               v-model="searchRole.active"/>
                        <label :for="searchRole.name">{{ $lang(searchRole.name) }}</label>
                    </div>
                </div>

                <div>
                    <input type="checkbox" id="active" name="active" v-model="searchParams.active"/>
                    <label for="active">{{ $lang('Aktywny') }}</label>

                    <button class="pull-right btn btn-primary mb-5" v-on:click="generate(1)">
                        {{ $lang('Szukaj') }}
                    </button>

                    <reload-button class="pull-right mb-5 mx-3"></reload-button>

                </div>
            </div>
        </div>
        <person-add-modal
            :add_route="add_route"
            :check_email_route="check_email_route"
            :upload_image_route="upload_image_route"
            :delete_image_route="delete_image_route"
            :sbs_id="sbs_id"
            :user_id="user_id"
            :libraries="libraries"
            :roles="rolesModal"
            :admin_roles="adminRoles"
            :customer_roles="customerRoles"
            :default_role_name="default_role_name"
            :current_project="current_project"
            :auth_type="auth_type"
            :library_id="library_id"
        ></person-add-modal>

        <div id="table">
            <pagination-component
                :pagination="pagination"
                :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
            ></pagination-component>
            <table class="table simple-table table-striped table-sm">
                <thead class="thead-dark">
                <tr>
                    <th scope="col">{{ $lang('Nazwisko') }}</th>
                    <th scope="col">{{ $lang('Imię') }}</th>
                    <th scope="col">{{ $lang('E-mail') }}</th>
                    <th scope="col">{{ $lang('Biblioteka') }}</th>
                    <th scope="col">{{ $lang('Rola w Bibliotece') }}</th>
                    <th scope="col" v-if="admin">{{ $lang('Akcje') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="pagination.total===0" class="table-light">
                    <th>
                        {{ $lang('Brak osób: zmień filtry wyszukiwania') }}
                    </th>
                </tr>
                <tr v-else v-for="person in people">
                    <td :data-title="$lang('Nazwisko')">
                        <i title="Osoba jest aktywna" class="fa fa-check mr-3" aria-hidden="true"
                           :style="'visibility: '+ (person.active ? 'visible':'hidden')"></i>
                        {{ person.surname || "-" }}
                    </td>
                    <td :data-title="$lang('Imię')">{{ person.name || "-" }}</td>
                    <td :data-title="$lang('E-mail')">{{ person.email || "-" }}</td>
                    <td :data-title="$lang('Nazwa Biblioteki')">{{ person.libraryName }}</td>
                    <td :data-title="$lang('Rola w Bibliotece')">
                        <template v-if="person.role">{{ person.role.name }}</template>
                        <template v-else>{{ '-' }}</template>
                    </td>
                    <td v-if="admin">
                        <a class="mr-3" href="#" data-toggle="modal" v-on:click="selectedPerson=person"
                           data-target="#delete_person_modal">{{ $lang('Usuń') }}</a>
                        <a class="mr-3" href="#" data-toggle="modal" v-on:click="selectedPerson=person"
                           data-target="#edit_person_modal">{{ $lang('Edytuj') }}</a>
                        <a class="mr-3" :href="people_roles_route+'/'+person.id" v-if="current_project === 'ORACLE'">
                            {{ $lang('Role projektowe') }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
            <pagination-component
                :pagination="pagination"
                :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
            ></pagination-component>

            <person-delete-modal :person=selectedPerson :delete_route="delete_route" :pre_delete_route="pre_delete_route"></person-delete-modal>
            <person-edit-modal :check_email_route="check_email_route"
                               :person=selectedPerson
                               :edit_route="edit_route"
                               :upload_image_route="upload_image_route"
                               :delete_image_route="delete_image_route"
                               :sbs_id="sbs_id"
                               :roles="rolesModal"
                               :admin_roles="adminRoles"
                               :customer_roles="customerRoles"
                               :current_project="current_project"
                               :auth_type="auth_type"
            ></person-edit-modal>
        </div>

    </div>
</template>

<script>
import {EventBus} from "../../mixins/event-bus";
import PersonEditModal from "./person-edit-modal";
import ReloadButton from "../reload-button";
import PersonAddModal from "./person-add-modal.vue";
import PaginationComponent from "../pagination-component.vue";
import PersonDeleteModal from "./person-delete-modal.vue";

export default {
    name: 'person-index',
    components: {PersonDeleteModal, PaginationComponent, PersonAddModal, ReloadButton, PersonEditModal},
    props: {
        return_route: String,
        add_route: String,
        edit_route: String,
        delete_route: String,
        pre_delete_route: String,
        search_route: String,
        people_roles_route: String,
        upload_image_route: String,
        delete_image_route: String,
        sbs_role_name: String,
        default_role_name: String,
        libraries: Array,
        roles: Array,
        sbs_id: Number,
        user_id: Number,
        library_id: Number|null,
        admin: Boolean,
        search_form: Boolean,
        check_email_route: String,
        current_project: String,
        auth_type: String
    },
    data() {
        return {
            pagination: [],
            people: [],
            selectedPerson: null,
            rolesModal: [],
            customerRoles: [],
            adminRoles: [],
            searchParams: {
                name: '',
                surname: '',
                email: '',
                library: '',
                worker_type: 'all',
                active: true,
                programmer: false,
                installation: false,
                consultant: false,
                roles: [],
            },
        }
    },
    methods: {
        onEnterSearch() {
            if(this.searchParams.surname !== ''
                || this.searchParams.name !== ''
                || this.searchParams.email !== '') {
                this.generate(1);
            }
        },
        generate(page, personId = false) {
            let self = this;
            let searchParams = self.searchParams;
            searchParams.page = page;
            personId ? searchParams.personId = personId : delete searchParams.personId;
            axios({
                method: 'get',
                url: self.search_route,
                params: searchParams
            })
                .then(function (response) {
                    self.pagination = response.data;
                    self.people = self.pagination.data;
                    document.getElementById("table").scrollIntoView();
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        setEventBusListenerPages() {
            EventBus.$on('changePage', ({value}) => {
                this.generate(value);
            });
        },
        prepareSearchRoles() {
            this.roles.forEach((role) => {
                this.searchParams.roles.push({
                    id: role.id,
                    active: false,
                    name: role.name
                });
            })
        }
    },
    created() {
        this.prepareSearchRoles();
        this.generate(1);
        this.setEventBusListenerPages();

        this.rolesModal = this.roles.filter(role => role.name !== this.sbs_role_name);
        this.adminRoles = this.roles.filter(role => !role.is_customer);
        this.customerRoles = this.roles.filter(role => role.is_customer);
    },
    computed: {
        isFiltered() {
            return (this.searchParams.name !== '' ||
                this.searchParams.surname !== '' ||
                this.searchParams.email !== '' ||
                this.searchParams.library !== '' ||
                this.searchParams.worker_type !== 'all' ||
                this.searchParams.active !== false)
        }
    }
}
</script>
